import React from 'react';
import { bool, func, object, string } from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { actionValues } from '../../actions/constants';
import { actionCreators } from '../../actions';

import Logo from '../Logo/Logo';
import Notifications from '../Notifications/Notifications';
import SearchBar from '../SearchBar/SearchBar';
import AccountNav from '../AccountNav/AccountNav';
import Likes from '../Likes/Likes';
import CartNav from '../CartNav/CartNav';

import styles from './TopBar-style.scss';

let TopBar = (props) => {
    const {
        disableStickyNav,
        hasRootPendingRefetch,
        hasUserId,
        hasUser,
        isClient,
        openDrawer,
        user,
        userId,
        viewer
    } = props;

    const barClasses = classnames({
        [styles.bar]: true,
        [styles.disableSticky]: disableStickyNav
    });

    return (
        <div className={barClasses} onMouseOver={openDrawer}>
            <div className={`${styles.barContent} js-nav-utils-wrap`}>
                <div className={styles.leftContainer}>
                    <Logo />
                    <SearchBar
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        isClient={isClient}
                        viewer={viewer}
                    />
                </div>
                <div className={styles.rightContainer}>
                    <AccountNav
                        isClient={isClient}
                        hasUser={hasUser}
                        hasUserId={hasUserId}
                        user={user}
                    />
                    <Notifications
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        hasUserId={hasUserId}
                        isClient={isClient}
                        userId={userId}
                        viewer={viewer}
                        initialViewer={viewer}
                        user={user}
                    />
                    <Likes
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        hasUserId={hasUserId}
                        fetchNewEvents={hasUserId && isClient && !hasRootPendingRefetch}
                        isClient={isClient}
                        userId={userId}
                        viewer={viewer}
                    />
                    <CartNav
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        hasUserId={hasUserId}
                        isClient={isClient}
                        user={user}
                        userId={userId}
                        viewer={viewer}
                    />
                </div>
            </div>
        </div>
    );
};

TopBar.propTypes = {
    disableStickyNav: bool,
    hasRootPendingRefetch: bool,
    hasUser: bool,
    hasUserId: bool,
    isClient: bool,
    openDrawer: func,
    user: object,
    userId: string,
    viewer: object
};

const mapDispatchToProps = (dispatch) => ({
    openDrawer: () => {
        dispatch(actionCreators.setDrawerAnimation(actionValues.drawerAnimations.SLIDE_IN));
    }
});

TopBar = connect(null, mapDispatchToProps)(TopBar);

export default createFragmentContainer(
    TopBar,
    {
        viewer: graphql`
            fragment TopBar_viewer on Viewer {
                ...CartNav_viewer
                ...Likes_viewer
                ...Notifications_viewer
                ...Notifications_initialViewer
                ...SearchBar_viewer
            }
        `,
        user: graphql`
            fragment TopBar_user on User {
                ...AccountNav_user
                ...CartNav_user
                ...Notifications_user
            }
        `
    }
);



// WEBPACK FOOTER //
// ./src/components/TopBar/TopBar.jsx